import { render, staticRenderFns } from "./storage-long-fee.vue?vue&type=template&id=6c84719c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./storage-long-fee.vue?vue&type=script&lang=js&"
export * from "./storage-long-fee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c84719c",
  null
  
)

export default component.exports